<div class="modal-container">
  <div class="modal-body">
    <angular-editor [placeholder]="'Enter text here...'" [(ngModel)]="popupContent" [config]="editorConfig">
    </angular-editor>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn-secondary" (click)="onCancel()">Cancel</button>
    <button type="button" class="btn-main" (click)="onSave()">Save</button>
  </div>
</div>